import React, {Component} from 'react';
import t from 'tcomb-form';
import classNames from 'classnames';

export default class FormDropdown extends Component {
    static displayName = 'FormDropdown';

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    handleClick = (value, e) => {
        e.preventDefault();
        this.setState({
            value
        });
        this.props.onChange(value, this.props.ctx.path);
    };

    isValueNully() {
        return this.state.value === null;
    }

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const label = this.props.options.label || this.props.ctx.label;
        const options = this.props.options.options || this.props.type.meta.map;
        const {disabledOptions} = this.props.options;
        const {value, hasError} = this.state;
        const currentValue = options[value] || options[0];

        const optionNodes = Object.keys(options).map(k => {
            const value = options[k];

            return (
                <li onClick={this.handleClick.bind(this, k)} key={k}>
                    <a href="#">{value}</a>
                </li>
            );
        });

        const disabledOptionNodes = (disabledOptions || []).map((o, i) => (
            <li className="disabled" key={i}>
                <a>{o}</a>
            </li>
        ));

        return (
            <div className={classNames('form-group', hasError && 'has-error', 'form-dropdown')}>
                <label className="control-label">{label}</label>
                <div className="dropdown">
                    <button
                        className="btn btn-default dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                    >
                        <span>{currentValue}</span>
                        <div className="pointer" />
                    </button>
                    <ul className="dropdown-menu">
                        {optionNodes}
                        {disabledOptionNodes}
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_dropdown.js